<template>
  <section id="qc-charts-filters">
    <div class="filter-bar" v-loading="loading">
      <el-form class="filterForm">
        <el-row :gutter="20" type="flex">
          <el-col :xl="6" :lg="6">
            <div class="each-table-data-edit">
              <el-form-item class="mb-15">
                <label for="text">
                  Start Date - End Date
                  <span class="star">*</span>
                </label>
                <el-date-picker
                  v-model="value1"
                  type="daterange"
                  range-separator="To"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  format="MM-DD-YYYY"
                  :disabled-date="disabledDate"
                  value-format="YYYY-MM-DD"
                  @change="fetchResultFiles"
                >
                </el-date-picker>
              </el-form-item>
            </div>
          </el-col>

          <el-col :xl="12" :lg="12">
            <div
              class="each-table-data-edit"
              :class="{ disable: !value1, 'cursor-pointer': value1 }"
            >
              <div class="checkbox-alignment">
                <el-checkbox
                  active-text="Only QC Data Files"
                  class="mr-10"
                  v-model="only_qc_data_file"
                  @change="fetchResultFiles"
                >
                  Only QC Data Files
                </el-checkbox>
                <el-checkbox
                  active-text="Only UTAKHC files"
                  v-model="only_utakhc"
                  @change="fetchResultFiles"
                >
                  Show UTAK HC1 Graphs
                </el-checkbox>
              </div>
              <el-form-item class="mb-15">
                <label for="text">
                  Result Files (Multiple)
                  <span class="star">*</span>
                </label>
                <div>
                  <el-select
                    v-model="selectedResultFiles"
                    multiple
                    clearable
                    collapse-tags
                    placeholder="Select"
                    popper-class="custom-header"
                    :max-collapse-tags="1"
                    :disabled="!value1"
                    class="custom-select-dropdown"
                  >
                    <el-checkbox
                      v-model="checkAll"
                      :indeterminate="indeterminate"
                      @change="handleCheckAll"
                      class="custom-checkbox"
                    >
                      All
                    </el-checkbox>
                    <el-option
                      v-for="(item, index) in getQCResultFiles"
                      :key="index"
                      :label="item.name"
                      :value="item._id"
                      @change="clearGraph"
                    >
                      <span style="float: left">{{ item.name }}</span>
                      <span
                        style="
                          float: right;
                          color: #8492a6;
                          font-size: 13px;
                          margin-left: 10px;
                        "
                        v-if="item.only_qc_data_file"
                        >QC Data File</span
                      >
                      <span
                        style="
                          float: right;
                          color: #8492a6;
                          font-size: 13px;
                          margin-left: 10px;
                        "
                        v-if="item.only_utakhc"
                        >UTAKHC Data File</span
                      >
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </div>
          </el-col>
          <el-col :xl="6" :lg="6" v-if="!only_utakhc">
            <div class="each-table-data-edit">
              <el-form-item class="mb-15">
                <label for="text">
                  Confirmation Test <span class="star">*</span>
                </label>

                <el-select
                  v-model="selectedTest"
                  value-key="_id"
                  placeholder="Select"
                  filterable
                  @change="setValueAndTest"
                  clearable
                  :disabled="!selectedResultFiles"
                >
                  <el-option
                    v-for="item in this.options"
                    :key="item._id"
                    :label="item.name"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <FormError errorName="drug"></FormError>
              </el-form-item>
            </div>
          </el-col>

          <el-col :xl="6" :lg="6" v-if="!only_utakhc">
            <div
              class="each-table-data-edit"
              :class="{
                disable: !selectedTest,
                'cursor-pointer': selectedTest,
              }"
            >
              <el-form-item class="mb-15">
                <label for="text">
                  QC Levels (Multiple) <span class="star">*</span>
                </label>
                <el-select
                  v-model="selectedLevels"
                  placeholder="Select QC Levels"
                  filterable
                  multiple
                  collapse-tags
                  @change="checkQCLevels"
                  :disabled="!selectedTest"
                >
                  <el-option
                    v-for="(item, index) in getQCLevelsByLab"
                    :key="index"
                    :label="item.value"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :xl="12" :lg="12" v-if="!only_utakhc"> </el-col>
          <el-col :xl="6" :lg="6">
            <div class="qc-chart-buttons">
              <el-button
                class="generate"
                @click="generateCharts"
                :disabled="disableGenerateCharts"
                >GENERATE</el-button
              >

              <el-button
                class="print"
                @click="goToPrintView"
                :disabled="disablePrintCharts"
                >PRINT</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="results-section" v-if="!loading">
      <div
        class="results-section-header justify-content-between"
        v-if="!disablePrintCharts && !only_utakhc && this.value1"
      >
        <div class="drug-section">
          <h3>
            Drug: <span class="value"> {{ value }}</span>
          </h3>
        </div>
        <div class="date-section">
          <h3>
            From-Date:
            <span class="value">{{ formatDate(this.value1[0]) }}</span>
          </h3>
          <h3>
            To-Date: <span class="value">{{ formatDate(this.value1[1]) }}</span>
          </h3>
        </div>
      </div>
      <div
        class="results-section-header justify-content-end"
        v-if="!disablePrintCharts && only_utakhc && this.value1"
      >
        <div class="date-section">
          <h3>
            From-Date: <span class="value">{{ this.value1[0] }}</span>
          </h3>

          <h3>
            To-Date: <span class="value">{{ this.value1[1] }}</span>
          </h3>
        </div>
      </div>
      <div class="qc1-to-qc4">
        <div
          v-if="
            Qc1ReportData && Qc1ReportData.data && Qc1ReportData.data.length
          "
        >
          <QC1
            v-if="
              Qc1ReportData && Qc1ReportData.data && Qc1ReportData.data.length
            "
            :qc1Data="Qc1ReportData"
          ></QC1>
        </div>
        <div
          v-if="
            Qc2ReportData && Qc2ReportData.data && Qc2ReportData.data.length
          "
        >
          <QC2
            v-if="
              Qc2ReportData && Qc2ReportData.data && Qc2ReportData.data.length
            "
            :qc2Data="Qc2ReportData"
          ></QC2>
        </div>

        <QC3
          v-if="
            Qc3ReportData && Qc3ReportData.data && Qc3ReportData.data.length
          "
          :qc3Data="Qc3ReportData"
        ></QC3>
        <QC4
          v-if="
            Qc4ReportData && Qc4ReportData.data && Qc4ReportData.data.length
          "
          :qc4Data="Qc4ReportData"
        ></QC4>
      </div>
      <!-- start mgh -->
      <div class="mghqc1-to-mghqc4">
        <MghQC1
          v-if="
            MghQc1ReportData &&
            MghQc1ReportData.data &&
            MghQc1ReportData.data.length
          "
          :qc1Data="MghQc1ReportData"
        ></MghQC1>
        <MghQC2
          v-if="
            MghQc2ReportData &&
            MghQc2ReportData.data &&
            MghQc2ReportData.data.length
          "
          :qc2Data="MghQc2ReportData"
        ></MghQC2>
        <MghQC3
          v-if="
            MghQc3ReportData &&
            MghQc3ReportData.data &&
            MghQc3ReportData.data.length
          "
          :qc3Data="MghQc3ReportData"
        ></MghQC3>
        <MghQC4
          v-if="
            MghQc4ReportData &&
            MghQc4ReportData.data &&
            MghQc4ReportData.data.length
          "
          :qc4Data="MghQc4ReportData"
        ></MghQC4>
      </div>
      <div class="qc1arearetention-to-qc4arearetention">
        <!-- end mgh -->
        <QC1AreaRetention
          v-if="
            Qc1ReportData &&
            Qc1ReportData.data &&
            Qc1ReportData.data.length &&
            visibleRetentionArea
          "
          :qc1Data="Qc1ReportData"
        ></QC1AreaRetention>
        <QC2AreaRetention
          v-if="
            Qc2ReportData &&
            Qc2ReportData.data &&
            Qc2ReportData.data.length &&
            visibleRetentionArea
          "
          :qc2Data="Qc2ReportData"
        ></QC2AreaRetention>
        <QC3AreaRetention
          v-if="
            Qc3ReportData &&
            Qc3ReportData.data &&
            Qc3ReportData.data.length &&
            visibleRetentionArea
          "
          :qc3Data="Qc3ReportData"
        ></QC3AreaRetention>
        <QC4AreaRetention
          v-if="
            Qc4ReportData &&
            Qc4ReportData.data &&
            Qc4ReportData.data.length &&
            visibleRetentionArea
          "
          :qc4Data="Qc4ReportData"
        ></QC4AreaRetention>
      </div>

      <!-- start mgh -->
      <div class="mghqc1-arearetention">
        <MghQC1AreaRetention
          v-if="
            MghQc1ReportData &&
            MghQc1ReportData.data &&
            MghQc1ReportData.data.length &&
            visibleRetentionArea
          "
          :qc1Data="MghQc1ReportData"
        ></MghQC1AreaRetention>
        <MghQC2AreaRetention
          v-if="
            MghQc2ReportData &&
            MghQc2ReportData.data &&
            MghQc2ReportData.data.length &&
            visibleRetentionArea
          "
          :qc2Data="MghQc2ReportData"
        ></MghQC2AreaRetention>
        <MghQC3AreaRetention
          v-if="
            MghQc3ReportData &&
            MghQc3ReportData.data &&
            MghQc3ReportData.data.length &&
            visibleRetentionArea
          "
          :qc3Data="MghQc3ReportData"
        ></MghQC3AreaRetention>
        <MghQC4AreaRetention
          v-if="
            MghQc4ReportData &&
            MghQc4ReportData.data &&
            MghQc4ReportData.data.length &&
            visibleRetentionArea
          "
          :qc4Data="MghQc4ReportData"
        ></MghQC4AreaRetention>
      </div>
      <!-- end mgh -->
      <div>
        <UTAKHC
          v-if="utakhcData && utakhcData.data && utakhcData.data.length"
          :utakhcData="utakhcData"
        ></UTAKHC>
      </div>
    </div>

    <div class="text-center pt-30" v-if="noData">
      <div class="empty-msg">
        <img
          src="@/assets/img/icons/empty.png"
          alt="empty"
          class="image"
          width="50"
        />
        <p class="mt-30">
          Sorry we couldn't find any matches for that<br />
          <span class="black6 body-fs">Please select with another options</span>
        </p>
      </div>
    </div>
  </section>
</template>
<script>
// for dlw
import QC1 from "@/components/QCCharts/QC1";
import QC2 from "@/components/QCCharts/QC2";
import QC3 from "@/components/QCCharts/QC3";
import QC4 from "@/components/QCCharts/QC4";
import QC1AreaRetention from "@/components/QCCharts/QC1AreaRetention";
import QC2AreaRetention from "@/components/QCCharts/QC2AreaRetention";
import QC3AreaRetention from "@/components/QCCharts/QC3AreaRetention";
import QC4AreaRetention from "@/components/QCCharts/QC4AreaRetention";

// for microgen
import MghQC1 from "@/components/QCCharts/microgen/QC1";
import MghQC2 from "@/components/QCCharts/microgen/QC2";
import MghQC3 from "@/components/QCCharts/microgen/QC3";
import MghQC4 from "@/components/QCCharts/microgen/QC4";
import MghQC1AreaRetention from "@/components/QCCharts/microgen/QC1AreaRetention";
import MghQC2AreaRetention from "@/components/QCCharts/microgen/QC2AreaRetention";
import MghQC3AreaRetention from "@/components/QCCharts/microgen/QC3AreaRetention";
import MghQC4AreaRetention from "@/components/QCCharts/microgen/QC4AreaRetention";

import UTAKHC from "@/components/QCCharts/UTAKHC";
import { mapGetters } from "vuex";
import ChartsHelper from "@/mixins/ChartsHelper";
import Highcharts from "@/config/highcharts";
import moment from "moment";
import FormError from "@/components/misc/FormError";

window.qc1Chart = null;
window.qc1AreaChart = null;
window.qc1RetentionChart = null;

window.qc2Chart = null;
window.qc2AreaChart = null;
window.qc2RetentionChart = null;

window.qc3Chart = null;
window.qc3AreaChart = null;
window.qc3RetentionChart = null;

window.qc4Chart = null;
window.qc4AreaChart = null;
window.qc4RetentionChart = null;

window.utakhcChart = null;

window.mghQc1Chart = null;
window.mghQc1AreaChart = null;
window.mghQc1RetentionChart = null;

window.mghQc2Chart = null;
window.mghQc2AreaChart = null;
window.mghQc2RetentionChart = null;

window.mghQc3Chart = null;
window.mghQc3AreaChart = null;
window.mghQc3RetentionChart = null;

window.mghQc4Chart = null;
window.mghQc4AreaChart = null;
window.mghQc4RetentionChart = null;

export default {
  components: {
    QC1,
    QC2,
    QC3,
    QC4,
    QC1AreaRetention,
    QC2AreaRetention,
    QC3AreaRetention,
    QC4AreaRetention,
    UTAKHC,
    MghQC1,
    MghQC2,
    MghQC3,
    MghQC4,
    MghQC1AreaRetention,
    MghQC2AreaRetention,
    MghQC3AreaRetention,
    MghQC4AreaRetention,

    FormError,
  },
  mixins: [ChartsHelper],
  data() {
    return {
      selectedCheckValue: "",
      checkAll: false,
      indeterminate: false,
      loading: false,
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      options: [],
      value: "",
      test: "",
      value1: "",
      Qc1ReportData: {
        categories: [],
        data: [],
      },
      Qc2ReportData: {
        categories: [],
        data: [],
      },
      Qc3ReportData: {
        categories: [],
        data: [],
      },
      Qc4ReportData: {
        categories: [],
        data: [],
      },
      utakhcData: {
        categories: [],
        data: [],
      },
      // for microgen
      MghQc1ReportData: {
        categories: [],
        data: [],
      },
      MghQc2ReportData: {
        categories: [],
        data: [],
      },
      MghQc3ReportData: {
        categories: [],
        data: [],
      },
      MghQc4ReportData: {
        categories: [],
        data: [],
      },
      noData: false,
      orderBy: "drug",
      orderType: "asc",
      resultsLoading: false,
      selectedResultFiles: "",
      selectedLevels: [],
      levels: [
        { value: "ALL", is_all: true },
        { value: "QCL", labs: ["DLW"] },
        { value: "QCM", labs: ["DLW"] },
        { value: "QCH", labs: ["DLW"] },
        { value: "QC 1", labs: ["MHC", "MICROGEN"] },
        { value: "QC 2", labs: ["MHC", "MICROGEN"] },
        { value: "QC 3", labs: ["MHC", "MICROGEN"] },
        { value: "QC 4", labs: ["MHC", "MICROGEN"] },
        { value: "CALIBRATION", labs: ["DLW", "MHC", "MICROGEN"] },
      ],
      selectedTest: "",
      only_qc_data_file: false,
      only_utakhc: false,
      visibleRetentionArea: false,
    };
  },
  mounted() {
    this.fetchMedications();
    this.fetchResultFiles();
    this.clearCharts();
  },
  computed: {
    ...mapGetters("qcCharts", [
      "getQCChartReportData",
      "getQCChartReportValidationErrors",
      "getConfirmationTests",
      "getQCResultFiles",
    ]),
    ...mapGetters("profile", ["getProfileData"]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    disableGenerateCharts() {
      if (
        // this.value &&
        // this.value1 &&
        this.value1.length == 2 &&
        this.getQCResultFiles &&
        this.getQCResultFiles.length &&
        this.selectedResultFiles &&
        this.selectedResultFiles.length &&
        this.selectedTest &&
        this.selectedLevels &&
        this.selectedLevels.length
      ) {
        return false;
      }
      return true;
    },
    disablePrintCharts() {
      if (
        (this.Qc1ReportData &&
          this.Qc1ReportData.data &&
          this.Qc1ReportData.data.length) ||
        (this.Qc2ReportData &&
          this.Qc2ReportData.data &&
          this.Qc2ReportData.data.length) ||
        (this.Qc3ReportData &&
          this.Qc3ReportData.data &&
          this.Qc3ReportData.data.length) ||
        (this.Qc4ReportData &&
          this.Qc4ReportData.data &&
          this.Qc4ReportData.data.length) ||
        (this.MghQc1ReportData &&
          this.MghQc1ReportData.data &&
          this.MghQc1ReportData.data.length) ||
        (this.MghQc2ReportData &&
          this.MghQc2ReportData.data &&
          this.MghQc2ReportData.data.length) ||
        (this.MghQc3ReportData &&
          this.MghQc3ReportData.data &&
          this.MghQc3ReportData.data.length) ||
        (this.MghQc4ReportData &&
          this.MghQc4ReportData.data &&
          this.MghQc4ReportData.data.length) ||
        (this.utakhcData && this.utakhcData.data && this.utakhcData.data.length)
      ) {
        return false;
      }
      return true;
    },
    getQCLevelsByLab() {
      let labCode = "";
      if (
        this.getProfileData &&
        this.getProfileData.lab &&
        this.getProfileData.lab.lab_code
      ) {
        labCode = this.getProfileData.lab.lab_code;
      }
      return this.levels.filter((level) => {
        return level.is_all || level.labs.indexOf(labCode) != -1;
      });
    },
    removeDuplicationsFromOptions() {
      const filteredOptions = this.options.filter(
        (item) => item.name !== "Amphetamine"
      );
      const uniqueMap = new Map();
      filteredOptions.forEach((item) => {
        uniqueMap.set(item.name, item);
      });
      return Array.from(uniqueMap.values());
    },
  },
  watch: {
    selectedResultFiles(val) {
      if (val.length === 0) {
        this.checkAll = false;
        this.indeterminate = false;
      } else if (val.length === this.getQCResultFiles.length) {
        this.checkAll = true;
        this.indeterminate = false;
      } else {
        this.checkAll = false;
      }
    },
  },
  methods: {
    handleCheckAll(val) {
      this.indeterminate = false;
      if (val) {
        this.selectedResultFiles = this.getQCResultFiles.map(
          (item) => item._id
        );
      } else {
        this.selectedResultFiles = [];
      }
    },
    clearGraph() {
      if (this.selectedResultFiles.length == 0) {
        this.clearCharts();
      }
    },
    checkResultFiles() {
      if (
        this.selectedResultFiles &&
        this.selectedResultFiles.length &&
        this.selectedResultFiles.length > 1 &&
        this.selectedResultFiles.indexOf("all") != -1
      ) {
        this.selectedResultFiles = this.selectedResultFiles.filter(
          (file) => file != "all"
        );
      }
    },
    setValueAndTest(changedTest) {
      this.value = changedTest.name;
      this.test = changedTest._id;
    },
    checkQCLevels() {
      if (
        this.selectedLevels &&
        this.selectedLevels.length &&
        this.selectedLevels.length > 1 &&
        this.selectedLevels.indexOf("all") != -1
      ) {
        this.selectedLevels = this.selectedLevels.filter(
          (file) => file != "all"
        );
      }
    },
    async generateCharts() {
      try {
        this.clearCharts();
        this.loading = true;
        if (this.only_utakhc) {
          let params = this.prepareParamsForUtakhc();
          await this.$store.dispatch("qcCharts/fetchQCChartReportData", params);
        } else {
          let params = this.prepareParams();
          await this.$store.dispatch("qcCharts/fetchQCChartReportData", params);
        }

        if (this.getQCChartReportData) {
          this.Qc1ReportData = this.getQCChartReportData.qcl
            ? { ...this.getQCChartReportData.qcl }
            : {};
          this.Qc2ReportData = this.getQCChartReportData.qcm
            ? { ...this.getQCChartReportData.qcm }
            : {};
          this.Qc3ReportData = this.getQCChartReportData.qch
            ? { ...this.getQCChartReportData.qch }
            : {};
          this.Qc4ReportData = this.getQCChartReportData.calibration
            ? { ...this.getQCChartReportData.calibration }
            : {};

          this.MghQc1ReportData = this.getQCChartReportData.qc1
            ? { ...this.getQCChartReportData.qc1 }
            : {};
          this.MghQc2ReportData = this.getQCChartReportData.qc2
            ? { ...this.getQCChartReportData.qc2 }
            : {};
          this.MghQc3ReportData = this.getQCChartReportData.qc3
            ? { ...this.getQCChartReportData.qc3 }
            : {};
          this.MghQc4ReportData = this.getQCChartReportData.qc4
            ? { ...this.getQCChartReportData.qc4 }
            : {};

          this.utakhcData = this.getQCChartReportData.utakhc
            ? { ...this.getQCChartReportData.utakhc }
            : {};
        }

        if (
          (this.Qc1ReportData &&
            this.Qc1ReportData.data &&
            this.Qc1ReportData.data.length) ||
          (this.Qc2ReportData &&
            this.Qc2ReportData.data &&
            this.Qc2ReportData.data.length) ||
          (this.Qc3ReportData &&
            this.Qc3ReportData.data &&
            this.Qc3ReportData.data.length) ||
          (this.Qc4ReportData &&
            this.Qc4ReportData.data &&
            this.Qc4ReportData.data.length) ||
          (this.Qc4ReportData &&
            this.Qc4ReportData.data &&
            this.Qc4ReportData.data.length) ||
          (this.MghQc1ReportData &&
            this.MghQc1ReportData.data &&
            this.MghQc1ReportData.data.length) ||
          (this.MghQc2ReportData &&
            this.MghQc2ReportData.data &&
            this.MghQc2ReportData.data.length) ||
          (this.MghQc3ReportData &&
            this.MghQc3ReportData.data &&
            this.MghQc3ReportData.data.length) ||
          (this.MghQc4ReportData &&
            this.MghQc4ReportData.data &&
            this.MghQc4ReportData.data.length) ||
          (this.MghQc4ReportData &&
            this.MghQc4ReportData.data &&
            this.MghQc4ReportData.data.length) ||
          (this.utakhcData &&
            this.utakhcData.data &&
            this.utakhcData.data.length)
        ) {
          this.noData = false;
        } else {
          this.noData = true;
        }

        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    prepareParamsForUtakhc() {
      let params = {
        from_date: this.value1[0],
        to_date: this.value1[1],
        only_utakhc: this.only_utakhc,
      };

      if (
        this.selectedResultFiles &&
        this.selectedResultFiles.indexOf("all") != -1
      ) {
        params.include_all_files = true;
      } else if (this.selectedResultFiles) {
        params.include_files = this.selectedResultFiles;
      }
      return params;
    },
    prepareParams() {
      let params = {
        from_date: this.value1[0],
        to_date: this.value1[1],
        drug: this.value,
        test: this.test,
        only_qc_data_file: this.only_qc_data_file,
        only_utakhc: this.only_utakhc,
      };

      if (
        this.selectedResultFiles &&
        this.selectedResultFiles.indexOf("all") != -1
      ) {
        params.include_all_files = true;
      } else if (this.selectedResultFiles) {
        params.include_files = this.selectedResultFiles;
      }

      params.levels = this.selectedLevels;
      return params;
    },
    async fetchMedications() {
      this.loading = true;
      await this.$store.dispatch("qcCharts/fetchAllConfirmationTests", {
        get_all: true,
        order_by: this.orderBy,
        order_type: this.orderType,
      });
      let unwantedCategoryCodes = [
        "ORAL_FLUID_TOX_CONFIRMATION",
        "D_L_Isomer",
        "SCREENING",
        "KRATOM",
        "WELLBUTRIN",
        "XYLAZINE",
      ];
      this.options =
        this.getConfirmationTests.filter(
          (option) => !unwantedCategoryCodes.includes(option.category_code)
        ) || [];
      this.loading = false;
    },
    downloadPdf() {
      let charts = [];

      if (window.qc1Chart) {
        charts.push(window.qc1Chart);
      }

      if (window.qc2Chart) {
        charts.push(window.qc2Chart);
      }

      if (window.qc3Chart) {
        charts.push(window.qc3Chart);
      }

      if (window.qc4Chart) {
        charts.push(window.qc4Chart);
      }

      if (window.mghQc1Chart) {
        charts.push(window.mghQc1Chart);
      }

      if (window.mghQc2Chart) {
        charts.push(window.mghQc2Chart);
      }

      if (window.mghQc3Chart) {
        charts.push(window.mghQc3Chart);
      }

      if (window.mghQc4Chart) {
        charts.push(window.mghQc4Chart);
      }

      if (window.qc1AreaChart) {
        charts.push(window.qc1AreaChart);
      }

      if (window.qc1RetentionChart) {
        charts.push(window.qc1RetentionChart);
      }

      if (window.qc2AreaChart) {
        charts.push(window.qc2AreaChart);
      }
      if (window.qc2RetentionChart) {
        charts.push(window.qc2RetentionChart);
      }
      if (window.qc3AreaChart) {
        charts.push(window.qc3AreaChart);
      }
      if (window.qc3RetentionChart) {
        charts.push(window.qc3RetentionChart);
      }

      if (window.qc4AreaChart) {
        charts.push(window.qc4AreaChart);
      }
      if (window.qc4RetentionChart) {
        charts.push(window.qc4RetentionChart);
      }

      if (window.mghQc1AreaChart) {
        charts.push(window.mghQc1AreaChart);
      }

      if (window.mghQc1RetentionChart) {
        charts.push(window.mghQc1RetentionChart);
      }

      if (window.mghQc2AreaChart) {
        charts.push(window.mghQc2AreaChart);
      }
      if (window.mghQc2RetentionChart) {
        charts.push(window.mghQc2RetentionChart);
      }
      if (window.mghQc3AreaChart) {
        charts.push(window.mghQc3AreaChart);
      }
      if (window.mghQc3RetentionChart) {
        charts.push(window.mghQc3RetentionChart);
      }

      if (window.mghQc4AreaChart) {
        charts.push(window.mghQc4AreaChart);
      }
      if (window.mghQc4RetentionChart) {
        charts.push(window.mghQc4RetentionChart);
      }

      if (window.utakhcChart) {
        charts.push(window.utakhcChart);
      }
      if (this.only_utakhc) {
        this.title = `From-Date: ${this.value1[0]} | To-Date: ${this.value1[1]}`;
        this.filename = `${this.value1[0]}_${this.value1[1]}`;
      }
      return Highcharts.exportCharts(charts, {
        type: "application/pdf",
      });
    },
    goToPrintView() {
      this.$store.commit(
        "qcCharts/setQCChartPrintReportData",
        this.getQCChartReportData,
        { root: true }
      );
      let chartConfig = this.downloadPdf();
      this.$store.commit("qcCharts/setQCChartChartSvgs", chartConfig, {
        root: true,
      });

      if (!this.only_utakhc) {
        let route = this.$router.resolve({
          name: "QCchart-print",
          query: {
            from_date: this.value1[0],
            to_date: this.value1[1],
            drug: this.value,
            test: this.test,
          },
        });
        window.open(route.href, "_blank");
      } else {
        let route = this.$router.resolve({
          name: "QCchart-print",
          query: {
            from_date: this.value1[0],
            to_date: this.value1[1],
          },
        });
        window.open(route.href, "_blank");
      }
    },
    async fetchResultFiles() {
      this.resultsLoading = true;
      this.selectedResultFiles = "";
      this.selectedTest = "";

      let params = {
        get_all: true,
        only_qc_data_file: this.only_qc_data_file,
        only_utakhc: this.only_utakhc,
      };
      if (this.value1 && this.value1.length == 2) {
        params.from_date = this.value1[0];
        params.to_date = this.value1[1];
      }

      await this.$store.dispatch("qcCharts/fetchResultFiles", params);

      this.resultsLoading = false;
    },
    clearCharts() {
      window.qc1Chart = null;
      window.qc1AreaChart = null;
      window.qc1RetentionChart = null;

      window.qc2Chart = null;
      window.qc2AreaChart = null;
      window.qc2RetentionChart = null;

      window.qc3Chart = null;
      window.qc3AreaChart = null;
      window.qc3RetentionChart = null;

      window.qc4Chart = null;
      window.qc4AreaChart = null;
      window.qc4RetentionChart = null;

      window.utakhcChart = null;

      // for microgen
      window.mghQc1Chart = null;
      window.mghQc1AreaChart = null;
      window.mghQc1RetentionChart = null;

      window.mghQc2Chart = null;
      window.mghQc2AreaChart = null;
      window.mghQc2RetentionChart = null;

      window.mghQc3Chart = null;
      window.mghQc3AreaChart = null;
      window.mghQc3RetentionChart = null;

      window.mghQc4Chart = null;
      window.mghQc4AreaChart = null;
      window.mghQc4RetentionChart = null;
    },
  },
};
</script>

<style lang="scss">
#qc-charts-filters {
  width: 94%;
  margin: auto;
  .disable {
    cursor: not-allowed;
    & * {
      cursor: not-allowed;
    }
  }
  .cursor-pointer {
    cursor: pointer;
    & * {
      cursor: pointer;
    }
  }
  .filter-bar {
    padding-top: 1rem;
    .filterForm {
      .checkbox-alignment {
        position: absolute;
        top: 0;

        right: 5px;
        .el-checkbox {
          height: 35px;
        }

        .el-checkbox__input .el-checkbox__inner {
          border-color: transparent;
          box-shadow: 0 0 0 1px #ced1d6;
          border-radius: 4px;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner {
          background: #0a5da6;
          border-color: #ffffff;
          box-shadow: 0 0 0 1px #ced1d6;
        }
        .el-checkbox__label {
          color: #34495e;
        }
      }
      .star {
        color: #eb5757;
      }
      .each-table-data-edit {
        position: relative;

        .el-form-item__content {
          color: #223147;

          font-weight: 500;
        }
        .el-input--suffix .el-input__inner {
          background: #ffffff;
          border: 1px solid #e0e0e1;
          border-radius: 5px;
        }
      }

      .el-form-item {
        display: block;
      }
    }
    .el-date-editor .el-range-input {
      text-align: start !important;
    }
  }
  .results-section {
    margin-top: 2rem;
    .results-section-header {
      display: flex;
      align-items: center;
      border: 1.2px solid #e7e7f7;
      border-radius: 5px;
      margin-bottom: 1rem;

      padding: 5px;
      .drug-section {
        h3 {
          color: rgba(0, 0, 0, 0.9);
          font-size: 16px;
          padding: 0 10px;
          .value {
            color: #0a5da6;
          }
        }
      }
      .date-section {
        display: flex;
        align-items: center;
        h3 {
          color: rgba(0, 0, 0, 0.9);
          padding: 0 10px;
          font-size: 16px;

          .value {
            color: #0a5da6;
            font-size: 15px;
            padding: 0 5px;
          }
        }
      }
    }
    .el-card.is-always-shadow {
      box-shadow: none;
    }
  }

  .text-center {
    .empty-msg {
      display: inline-block;

      padding: 1em;

      margin-top: 5%;
    }

    #qc-chart-print-view {
      width: 900px;
    }
  }
  .qc-chart-buttons {
    display: flex;
    margin-top: 40px;
    justify-content: flex-end;

    .generate {
      background-color: #eb5757;
      color: #ffffff;
      border: none;
      width: 175px;
    }
    .print {
      background-color: #0a5da6;
      color: #ffffff;
      border: none;
      width: 150px;
    }
  }
}
</style>
<style lang="scss" scoped>
.custom-checkbox-group {
  margin: 5px 15px 15px 15px;
  .el-checkbox {
    display: grid;
    grid-template-columns: 20px auto;
    height: 30px;
  }
  .el-select-dropdown__item {
    padding: 0 !important;
    &:hover {
      background: none !important;
      color: #606266 !important;
    }
  }
}
.custom-all-options {
  padding: 0;
  margin: 10px 15px 0 15px;
  label {
    display: block;
    height: 30px;
  }
  &:hover {
    background: none !important;
  }
}
.custom-header {
  .el-checkbox {
    display: flex;
    height: unset;
  }
}
.custom-checkbox {
  padding-left: 15px;
  padding-bottom: 10px;
  padding-top: 10px;
  background: #f5f5f5;
  margin-bottom: 10px;
}
.el-select-dropdown__item:hover {
  background: #f5f7fa !important;
  color: #333 !important;
}
.el-select-dropdown__item {
  padding-left: 38px;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    left: 12px;
    width: 15px;
    height: 15px;
    border: 1px solid #409eff;
    top: 50%;
    transform: translateY(-50%);
  }
}
.selected {
  &:before {
    content: "\2713";
    color: #409eff;
    position: absolute;
    left: 14px;
    font-weight: 800;
  }
}
</style>
